// src/components/billing/PlanAxisToggle.jsx — a segmented control over ONE axis
// of the plans grid (billing interval, or workspaces per licence).
//
// ⛔ IT DECIDES NOTHING. Its positions are handed in, built from the rows the
// server sent; picking one selects which existing row the card displays.
import React from 'react';
import { COLORS, FONT_SANS, RADII } from '../../constants/theme.js';

export default function PlanAxisToggle({ label, options, value, onChange, disabled = false }) {
  return (
    <div>
      <div style={{
        fontSize: 11, fontWeight: 600, color: COLORS.textSecondary,
        marginBottom: 6, fontFamily: FONT_SANS,
      }}>
        {label}
      </div>
      <div role="radiogroup" aria-label={label} style={{
        display: 'inline-flex', gap: 4, padding: 4,
        background: COLORS.field, borderRadius: RADII.control,
      }}>
        {options.map((o) => {
          const active = o.value === value;
          return (
            <button
              key={String(o.value)} type="button" role="radio" aria-checked={active}
              disabled={disabled} onClick={() => onChange(o.value)}
              style={{
                padding: '6px 14px', border: 'none', borderRadius: RADII.controlInner,
                background: active ? COLORS.surface : 'transparent',
                color: active ? COLORS.ink : COLORS.textSecondary,
                fontSize: 13, fontWeight: active ? 600 : 500, fontFamily: FONT_SANS,
                cursor: disabled ? 'not-allowed' : 'pointer',
              }}>
              {o.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
